import "../PageCommon.css";
import "./Profile.css";

const ProfilePage = () => {
  return (
    <div className="page__container">
      <div className="page__head">
      </div>
      <div className="page__body">
        <div className="page__label">
          <h2>Profile</h2>
        </div>
      </div>
    </div>
  );
}

export default ProfilePage;